import {ErrorsActionTypes} from './types/errors-action-types.interface'
import {createAction, props} from '@ngrx/store'
import {ErrorsInterface} from './types/errors-stan.interface'

export declare type ErrorsProps = {payload: ErrorsInterface}

export const toErrorsPage = createAction(ErrorsActionTypes.TO_ERROR_PAGE, props<ErrorsProps>())
export const logErrorToBackand = createAction(ErrorsActionTypes.LOG_ERROR_TO_BACKAND, props<{error: Error}>())
